import type { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { searchForAllCountriesStaticProps } from 'src/actions/searchActions';
import type { PathsTypes } from 'src/types/render-types';
import {
  fetchNewsletterPost,
  fetchNewsletterPosts,
} from '../../actions/newsletterActions';
import type { ArticleSlugProps } from '../../page-components/articles/articleSlug';
import { ArticleSlug } from '../../page-components/articles/articleSlug';

export default function NewsletterSlugPage(props: ArticleSlugProps) {
  return <ArticleSlug {...props} />;
}

export const getStaticProps: GetStaticProps<
  Record<string, unknown>,
  { slug: string; locale: string }
> = async ({ params, locale }) => {
  const slug = params?.slug ?? '';
  const blogPosts = await fetchNewsletterPosts({ page: 1, size: 100 });
  const blogPostId = blogPosts?.data.find((post) => {
    return post?.slug === slug;
  })?.id;

  try {
    const post = await fetchNewsletterPost(blogPostId?.toString() as string);
    const countries = await searchForAllCountriesStaticProps();

    if (!post || !countries) {
      throw new Error('Error fetching post or countries');
    }

    const similarArticles = await fetchNewsletterPosts({ page: 1, size: 4 });

    return {
      props: {
        ...(await serverSideTranslations(locale || 'en', [
          'common',
          'about',
          'partners',
          'navbar',
          'new-homepage',
          'new-navbar',
          'new-footer',
        ])),
        post: post || {},
        similarArticles: similarArticles?.data ?? null,
        countries: countries || [],
      },
      revalidate: 3600,
    };
  } catch (error) {
    console.log(error);
    return {
      props: {},
    };
  }
};

export const getStaticPaths = async () => {
  const blogPosts = await fetchNewsletterPosts({ page: 1, size: 100 });

  const slugs: string[] = [];

  blogPosts?.data.forEach((post) => {
    slugs?.push(post?.slug);
  });

  const paths: PathsTypes[] = slugs?.map((slugName: string) => ({
    params: { slug: slugName?.toString() },
  }));

  return { paths: paths, fallback: 'blocking' };
};
